import ManifestStart from "./start";
import PODScreen from "./pod";
import CollectScreen from './collect';
import ManifestFinish from "./finish";
import Clockin from "./clockin";
import Clockout from "./clockout";
import Report from "./report";

const routes = [
  {
    path: "/start",
    component: ManifestStart,
  },
  {
    path: "/pod",
    component: PODScreen,
  },
  {
    path: "/collect",
    component: CollectScreen,
  },
  {
    path: "/finish",
    component: ManifestFinish,
  },
  {
    path: "/clockin",
    component: Clockin,
  },
  {
    path: "/clockout",
    component: Clockout,
  },
  {
    path: "/schedule/update",
    component: Report,
  },
];

export default routes;
